<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>服务比价列表</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="right" @click="$router.back(-1)">
                <button class="swb-btn swb-btn-link"><i class="icon iconfont icon-fanhui2 mr5"></i>返回</button>
            </div>
        </div>
        <div class="tab-container small base mt20">
            <div class="tabs-nav">
                <ul class="head">
                    <li class="head-item" v-for="(text, value) in comparisonTypeList" :class="{'current': value == checkStateValue}" @click="changeStatue(value)">
                        <span>{{text}}</span>
                    </li>
                </ul>
            </div>
            <div class="tabs-content" style="min-height: 735px;">
                <ul class="body">
                    <li class="body-item">
                        <div class="" v-if="checkStateValue == 0">
                            <div class="content-subtitle" style="border: 1px solid #dadada">
                                <div class="form-row pos-rel" style="padding-right: 100px;">
                                    <div class="form-label">
                                        <label>当前比价服务名称:</label>
                                    </div>
                                    <div class="form-value width-1x">
                                        <el-input v-model="priceInqryServc.name"></el-input>
                                    </div>
                                    <div class="form-label">
                                        <label>当前比价服务单价</label>
                                    </div>
                                    <div class="form-value width-1x">
                                        <span>{{priceInqryServc.price}}元</span>
                                    </div>
                                    <div class="form-label">
                                        <label>&nbsp;</label>
                                    </div>
                                    <div class="pos-abs" style="top: 0; right: 25px">
                                        <button class="swb-btn swb-btn-small" @click.stop="searchName(true)">搜索</button>
                                    </div>
                                </div>
                            </div>
                            <div class="table-layout">
                                <el-table :data="priceReplyServcList" border style="width: 100%">
                                    <el-table-column prop="inqryNo" label="询价单号" align="left" show-overflow-tooltip>
                                        <template slot-scope="rows">
                                            <a class="swb-btn-link" @click.stop="toPriceInpryList(rows.row.inqryNo)">{{rows.row.inqryNo}}</a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="name" label="服务名称" align="left" show-overflow-tooltip></el-table-column>
                                    <el-table-column label="呈报单价(元)" sortable align="right" show-overflow-tooltip>
                                        <template slot-scope="rows">
                                            <span>{{parseFloat(rows.row.replyPrice).toFixed(2)}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="desc" label="说明" align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="merchantName" label="报价方名称" align="left" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="replyTime" label="报价时间" sortable align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="expireDate" label="截止日期" sortable align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="adopted" label="是否采纳" align="center" show-overflow-tooltip>
                                        <template slot-scope="rows">
                                            <el-tag v-if="rows.row.adopted" type="success" style="background-color: transparent; border: none" close-transition>
                                                <span>是</span>
                                            </el-tag>
                                            <el-tag v-else type="danger" style="background-color: transparent; border: none" close-transition>否</el-tag>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="block pagination-layout">
                                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                            </div>
                        </div>
                        <div class="" v-if="checkStateValue == 1">
                            <div class="content-subtitle" style="border: 1px solid #dadada">
                                <div class="form-row pos-rel" style="padding-right: 100px;">
                                    <div class="form-label">
                                        <label>当前比价服务名称:</label>
                                    </div>
                                    <div class="form-value">
                                        <el-input v-model="name"></el-input>
                                    </div>
                                    <div class="form-label">
                                        <label>当前比价服务单价</label>
                                    </div>
                                    <div class="form-value">
                                        <span>{{bidServc.price}}元</span>

                                    </div>
                                    <div class="form-label">
                                        <label>&nbsp;</label>
                                    </div>
                                    <div class="pos-abs" style="top: 0; right: 25px">
                                        <button class="swb-btn swb-btn-small" @click.stop="searchName(true)">搜索</button>
                                    </div>
                                </div>
                            </div>
                            <div class="table-layout">
                                <el-table :data="bidServcList" border style="width: 100%">
                                    <el-table-column prop="callDocNo" label="招标单号" align="left" show-overflow-tooltip>
                                        <template slot-scope="rows">
                                            <a class="swb-btn-link" @click.stop="toCallbidList(rows.row.callDocNo)">{{rows.row.callDocNo}}</a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="name" label="服务名称" align="left" show-overflow-tooltip></el-table-column>
                                    <el-table-column label="单价(元)" sortable align="right" show-overflow-tooltip>
                                        <template slot-scope="rows">
                                            <span>{{parseFloat(rows.row.price).toFixed(2)}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="desc" label="说明" align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="merchantName" label="投标方名称" align="left" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="bidTime" label="投标时间" sortable align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="resultPublishTime" label="公布时间" sortable align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="resultFlag" label="中标状态" align="center" show-overflow-tooltip>
                                        <template slot-scope="rows">
                                            <span v-if="rows.row.resultFlag == 0">未中标</span>
                                            <span v-if="rows.row.resultFlag == 1">已中标</span>
                                            <span v-if="rows.row.resultFlag == -1">已流标</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="block pagination-layout">
                                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    //
    import priceApi from '../../api/price'
    import tendBidApi from '../../api/tendBid'
    import userApi from '../../api/user'

    import SwbPriceInpryList from './PriceInpryList';
    Routes.add(SwbPriceInpryList);
    import SwbCallBidDocList from '../callbid/CallBidDocList';
    Routes.add(SwbCallBidDocList);

    export default{
        name: 'swb-servc-comparison',
        path: '/servc/price/compare/list',
        pathOld: '/servc/comparison/list',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '服务比价列表',
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                priceReplyServcList: [],
                comparisonTypeList: [
                    "询价",
                    "招标"
                ],
                userInfo: {},
                checkStateValue: 0,
                priceInqryServc: {
                    name: null
                },
                bidServcList: [],
                bidServc: {},
                name: null,
                initialResultFlag: {}
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.initialResultFlag = getEnumInfoWith("callBidResultFlag", 'name', 'Initial');

            this.getCurrentUserInfo();
        },
        methods: {
            parseFloat: function (price) {
                if(isNoB(price)) {
                    price = 0.00;
                }
                return Utils.parseFloat(price);
            },
            searchName: function (flag) {
                let type = this.checkStateValue;
                if(type == 0) {
                    this.getPriceReplyServcList(flag);
                } else {
                    this.getBidServcList(flag);
                }
            },
            getPriceInqryServcInfo: function () {
                let self = this;
                let id = self.$route.query.id;
                let postData = {};
                postData.id = id;
                priceApi.getPriceInqryServc(postData, function (result) {
                    if(result.type == 'info') {
                        self.priceInqryServc = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getBidServcInfo: function () {
                let self = this;
                let id = self.$route.query.id;
                let postData = {};
                postData.id = id;
                tendBidApi.getBidServc(postData, function (result) {
                    if(result.type == 'info') {
                        self.bidServc = result.data;
                        self.name = self.bidServc.name;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getCurrentUserInfo: function () {
                let self = this;
                let postData = {};
                let lastMsgBoxDlg = MsgBox.loading();
                userApi.getUserInfoByContext(postData, function (result) {
                    if(result.type == "info") {
                        self.userInfo = result.data;
                        let opreate = self.$route.query.opreate || null;
                        let ssuId = self.$route.query.ssuId || null;
                        if(opreate == null) {
                            if(ssuId != null) {
                                let id = self.$route.query.id || null;
                                if(id != null) {
                                    self.getPriceInqryServcInfo();
                                }
                                self.getPriceReplyServcList();
                            }
                        } else {
                            if(ssuId != null) {
                                let id = self.$route.query.id || null;
                                if(id != null) {
                                    self.getBidServcInfo();
                                }
                                self.checkStateValue = 1;
                                self.getBidServcList();
                            }
                        }
                        let name = self.$route.query.name || null;
                        if(name != null) {
                            self.name = name;
                            self.checkStateValue = 1;
                            self.getBidServcList(true);
                        }
                        lastMsgBoxDlg.close();
                    }
                });
            },
            changeStatue: function (value) {
                this.checkStateValue = value;
                if(value == 0) {
                    this.getPriceReplyServcList();
                } else {
                    this.getBidServcList();
                }
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getPriceReplyServcList();
            },
            getPriceReplyServcList: function (flag) {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};

                filterItems.inqryMerchantId = self.userInfo.scopeEntity.id;
                filterItems.inqryMerchantType = self.userInfo.scopeEntity.type;
                if(!Utils.isNoB(self.priceInqryServc.name) && flag) {
                    filterItems.name = self.priceInqryServc.name;
                    self.priceInqryServc = {};
                    self.priceInqryServc.name = filterItems.name;
                } else if(flag == null) {
                    filterItems.ssuId = self.$route.query.ssuId;
                }
                filterItems.replied = true;
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading("数据查询中.....");
                priceApi.getPriceReplyServcList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.priceReplyServcList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getBidServcList: function (flag) {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = {};

                filterItems.fstPartyId = self.userInfo.scopeEntity.id;
                filterItems.fstPartyType = self.userInfo.scopeEntity.type;
                if(!Utils.isNoB(self.name) && flag) {
                    filterItems.name = self.name;
                    self.bidServc = {};
                } else if(flag == null) {
                    filterItems.ssuId = self.$route.query.ssuId;
                }

                filterItems.resultFlag = self.initialResultFlag.value;
                let date = new Date();
                filterItems.callCloseTime = date.format('yyyy-MM-dd HH:mm');
                filterItems.bidden = true;
                postData.filterItems = filterItems;
                let theLoad = MsgBox.loading("数据查询中.....");
                tendBidApi.getBidServcPagedList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.bidServcList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            toPriceInpryList: function (no) {
                this.$router.push({
                    path: SwbPriceInpryList.path,
                    query: {
                        no: no
                    }
                });
            },
            toCallbidList: function (no) {
                this.$router.push({
                    path: SwbCallBidDocList.path,
                    query: {
                        no: no
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/priceInpry/ServcComparison.vue